var parent = require('../../es/instance/trim');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/instance/trim.js
// module id = 1122
// module chunks = 0